var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPic2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.21 92.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5c1e7;}.cls-2{fill:#fff;}.cls-3{fill:#baa1de;}.cls-4{fill:#ffed4a;}.cls-5{fill:none;stroke:#343a40;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.21,42.7c0,21.66-19.79,37.38-41.45,37.38S0,61.76,0,40.1,21.4,0,43.06,0,82.21,21,82.21,42.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.53,41.36c0,12.54-10.75,27.55-23.38,27.55s-28-11.94-28-24.48S30.38,17.71,43,17.71,64.53,28.83,64.53,41.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.39,21.35a10.37,10.37,0,0,1-20.73,0c0-5.67,4.85-8.88,10.57-8.88S64.39,15.68,64.39,21.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.91,71c0,10.83-3.25,21.65-9.95,21.65S16.53,79.91,16.53,69.08,20.25,53.5,27,53.5,36.91,60.22,36.91,71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20.81,33A6.89,6.89,0,1,1,7,33c0-3.88,3.26-6,7.06-6S20.81,29.13,20.81,33Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic2);
export default __webpack_public_path__ + "static/media/Pic2.19aa347267e87f5dba823423daf69527.svg";
export { ForwardRef as ReactComponent };